<div class="tw-relative tw-flex tw-items-center tw-gap-4 tw-p-4 tw-pr-9">
  <div class="toast-icon-chip tw-flex tw-shrink-0 tw-items-center tw-justify-center">
    <svg class="tw-h-6 tw-w-6 tw-text-white" aria-hidden="true">
      <use [attr.xlink:href]="'images/sprite.svg#' + iconName"></use>
    </svg>
  </div>

  <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5">
    @if (title) {
      <div class="tw-font-semibold tw-text-white" [attr.aria-label]="title">
        {{ title }}
      </div>
    }
    @if (message && !options.enableHtml) {
      <div role="alertdialog" aria-live="polite" class="tw-text-white" [attr.aria-label]="message">
        {{ message }}
      </div>
    }
  </div>

  @if (showAction) {
    <button
      type="button"
      class="tw-mr-4 tw-shrink-0 tw-font-semibold tw-text-white tw-underline"
      (click)="onAction()"
    >
      {{ actionLabel }}
    </button>
  }

  <button
    *ngIf="options.closeButton"
    (click)="remove()"
    type="button"
    class="toast-close-button"
    aria-label="Close"
  >
    <svg class="tw-h-5 tw-w-5 tw-text-white">
      <use [attr.xlink:href]="'images/sprite.svg#close'"></use>
    </svg>
  </button>
</div>
